import { render, staticRenderFns } from "./TableRejected.vue?vue&type=template&id=525d8aad&"
import script from "./TableRejected.vue?vue&type=script&lang=js&"
export * from "./TableRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports